module.exports = __webpack_public_path__ + "img/product_item_3.3309d38b.png";